/**
 * @fileoverview Resolve one form-security string: consumer `t` → English default.
 * @module @puffin-core/form-security/strings/resolveString
 *
 * Bound from the ONE shared implementation (`createStringResolver`), exactly as every
 * `@puffin-core` package that ships a `strings/` bundle does. A translator's return is treated as
 * MISSING — and the English default used — when it is nullish, empty, or THE KEY ECHOED BACK,
 * because the last of those is what react-i18next returns for an unregistered key. Without that
 * branch an unwired tree would render the raw dotted key as visible copy.
 *
 * @param {((key: string, params?: Object) => string|undefined|null)|undefined|null} t - Optional
 *   consumer translator.
 * @param {string} key - The string key.
 * @param {Object} [params] - Optional interpolation params forwarded to the consumer's `t`.
 * @returns {string|undefined} The resolved string, or `undefined` for a key the bundle lacks.
 */

import { createStringResolver } from '@puffin-core/i18n-bootstrap/strings-kit';

import { DEFAULT_FORM_SECURITY_STRINGS } from './en.js';

export const resolveString = createStringResolver(DEFAULT_FORM_SECURITY_STRINGS);

export default resolveString;
